import { render, staticRenderFns } from "./OrderCheck.vue?vue&type=template&id=24febc93&"
import script from "./OrderCheck.vue?vue&type=script&lang=js&"
export * from "./OrderCheck.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports